var map = {
	"./basic.js": "9437",
	"./channel.js": "94b4",
	"./comment.js": "9cbf",
	"./group.js": "cfbb",
	"./index.js": "c270",
	"./label.js": "5daa",
	"./material.js": "b533",
	"./media.js": "27e4",
	"./message.js": "5252",
	"./polyline.js": "e43c",
	"./region.js": "1649",
	"./regionAdmin.js": "9344",
	"./setting.js": "f6fa",
	"./shop.js": "ed68",
	"./spot.js": "ce31",
	"./storage.js": "c04c",
	"./user.js": "43b5",
	"./userAdmin.js": "05d0",
	"./vr.js": "a2c3",
	"./works.js": "7acd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f008";